/* eslint-disable */
<template>
  <div class="containter-fluid no-padding">
    <div class="row p-2">
      <div class="col-md-2" v-for="(prod, prodIndex) in calculatingProducts" v-bind:key="'prod-label-' + prod.URUN_ID">
        <label class="ml-2" v-bind:for="'prod-label-'+ prod.URUN_ID">{{prod.URUN_NAME}}</label>
        <input type="number" class="form-control btn-more-radius" :id="'prod-label-'+ prodIndex" 
          v-model="prod.QUANTITY" @keyup="calculate(e)" placeholder="">
      </div>
      <div class="col-md-4 align-middle">
        <label class="ml-2" for="exampleFormControlSelect1">GÖSTERİLEN MALZEMELER</label>
        <select v-model="listingMode" class="form-control btn-more-radius mr-2" id="exampleFormControlSelect1">
          <option value="0">Tüm Malzemeleri Göster</option>
          <option value="1">Eksik Olanları Göster</option>
          <option value="2">Yeterli Olanları Göster</option>
          <option value="3">Ortak Kullanılanları Göster</option>
        </select>
      </div>
      <div class="col-md-2 align-middle">
        <label class="text-right" for="exampleFormControlSelect1">&nbsp;</label>
        <button class="btn btn-success btn-more-radius float-right" @click="askProduction()">Üretimi Başlat</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <v-wait for="hesapla-loading">
          <template slot="waiting">
            <div class="vue-wait-class">
              <img src="static/loading.svg" />
              <p>Ürünler yükleniyor...</p>
            </div>
          </template>
          <table class="table table-bordered">
            <thead class="thead-light">
              <tr>
                <th style="width: 12%;" class="text-center" scope="col">DURUM</th>
                <th style="width: 18%;" scope="col">
                  <div class="text-truncate justify-content-between">
                    <p class="mx-1 mb-1">MALZEME</p>
                    <div class="custom-control custom-checkbox mx-1">
                      <input type="checkbox" id="is-lenoi-invoice" class="custom-control-input" v-model="malzemeCodeFirst">
                      <label class="custom-control-label light-text mt-1" for="is-lenoi-invoice">Malzeme Kodunu Vurgula</label>
                    </div>
                  </div>
                </th>
                <th style="width: 8%;" class="text-center" v-bind:key="'calc-prod-' + prod.URUN_ID"
                  scope="col" v-for="(prod) in calculatingProducts">{{prod.URUN_NAME}}</th>
                <th style="width: 10%;" class="text-center" scope="col">GEREKEN SAYI</th>
                <th style="width: 10%;" class="text-center" scope="col">LENOİ STOK</th>
                <th style="width: 10%;" class="text-center" scope="col">FABRİKA STOK</th>
                <th style="width: 10%;" class="text-center" scope="col">MALZEME EKSİĞİ</th>
              </tr>
            </thead>
            <tbody class="tbody-margin">
              <template v-for="malzeme in this.malzemeler">
                <tr v-show="listingMode == 0 || 
                  (listingMode == 1 && malzeme.IS_ENOUGH == 0) || 
                  (listingMode == 2 && malzeme.IS_ENOUGH == 1) ||
                  (listingMode == 3 && malzeme.QUANTITIES.filter(mm => mm.QTY > 0)).length > 1" 
                  :key="'trow-first-' + malzeme.MALZEME_ID" :class="{'background-success': malzeme.IS_ENOUGH == 1, 'background-danger': malzeme.IS_ENOUGH == 0}">
                  <td class="align-middle text-center">
                    <span v-if="malzeme.IS_ENOUGH == 0" class="btn btn-lg btn-more-radius bg-danger">
                      <i class="fas fa-times text-white"></i>
                    </span>
                    <span v-else class="btn btn-lg btn-more-radius bg-success">
                      <i class="fas fa-check text-white"></i>
                    </span>
                  </td>
                  <td class="align-middle justify-content-betwenn">
                    <p class="my-0 font-semi-bold">{{malzemeCodeFirst ? malzeme.MALZEME_CODE : malzeme.MALZEME_NAME}}</p>
                    <small class="text-muted">{{malzemeCodeFirst ? malzeme.MALZEME_NAME : malzeme.MALZEME_CODE}}</small>
                  </td>
                  <td v-for="(qty,qtyIndex) in malzeme.QUANTITIES" v-bind:key="'malz-count-' + qtyIndex"
                    class="align-middle text-center">{{qty.QTY}}</td>
                  <td class="align-middle text-center font-semi-bold">{{calcNeededTotal(malzeme.MALZEME_ID)}}</td>
                  <td class="align-middle text-center">{{malzeme.MALZEME_LENOI}}</td>
                  <td class="align-middle text-center">{{malzeme.MALZEME_FABRIKA}}</td>
                  <td class="align-middle text-center font-semi-bold">{{calcDifferenceMultiple(malzeme)}}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </v-wait>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="modalAskProduction" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-danger">
            <h5 class="modal-title text-white" id="trackNumberModalLabel">Dikkat !</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="uretim-starting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Üretim başlatılıyor...</p>
                </div>
              </template>
            </v-wait>
            <div class="container-fluid">
              <p class="lead font-semi-bold">Üretimi başlat komutunu verdiğinizde, kullanılacak olan malzemeler fabrika stokuna kaydırılacaktır.
              Devam etmek istediğinizden emin misiniz ?</p>
              <div class="mb-4"></div>
              <div class="row">
                <div class="col-md-12">
                  <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" id="self-out" class="custom-control-input" v-model="quantitiesByHand">
                    <label class="custom-control-label light-text" for="self-out">Fabrikaya gönderilen malzeme adetlerini kendim belirlemek istiyorum.</label>
                    <small id="self-out" class="form-text text-muted">
                      Bu seçeneği işaretlemeden üretimi başlat komutunu verirseniz; fabrika stoka aktarılacak olan malzeme adetleri üretim adedinin gereğince belirlenir.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-danger btn-more-radius" @click="startProduction(0)">Üretimi Başlat</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="modalQuantitiesByhand" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-danger">
            <h5 class="modal-title text-white" id="trackNumberModalLabel">Fabrikaya gönderilecek malzeme adetlerini girin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-body-fixed">
            <v-wait for="uretim-fabrika-stok">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Üretim başlatılıyor...</p>
                </div>
              </template>
            </v-wait>
            <div class="container-fluid">
              <div class="row mb-2 align-middle" v-for="mlzm in malzemeler" v-bind:key="'to-fabric-' + mlzm.MALZEME_ID">
                <label v-bind:for="'mlzm-to-fabric' + mlzm.MALZEME_ID"
                  class="col-sm-8 col-form-label font-semi-bold">{{mlzm.MALZEME_NAME}} - {{mlzm.MALZEME_CODE}}</label>
                <div class="col-sm-4 align-middle">
                  <input type="number" class="form-control" v-model="mlzm.TO_FABRIC" :id="'mlzm-to-fabric' + mlzm.MALZEME_ID" placeholder="">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-danger btn-more-radius" @click="startProduction(1)">Üretimi Başlat</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'UretimPage',
  components: {
  },
  data () {
    return {
      calculatingProducts: [],
      product: {},
      malzemeler: [],
      quantity: 0,
      listingMode: 0,
      quantitiesByHand: false,
      malzemeCodeFirst: true,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 3000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    getFilteredList : function() { 
      if(this.listingMode == 0) return this.malzemeler 
      else if(this.listingMode == 1) return this.malzemeler.filter(m => m.IS_ENOUGH == 0)
      else return this.malzemeler.filter(m => m.IS_ENOUGH == 1)
    }
  },
  methods: {
    getProduct() {
      console.log(this.$route.params)
      if(this.$route.params.id === undefined)
        return

      this.productId = this.$route.params.id
      this.product = {}
      this.$wait.start('product-creating')
      axios.post('/api/stok/urun?sessionid=' + this.getSessionId + '&urunId=' + this.$route.params.id)
      .then(response => {
        this.product = response.data[0]
        
        let cacheProds = response.data
        for(let i = 0; i < cacheProds.length; i++)
          cacheProds[i].QUANTITY = 1

        this.calculatingProducts = cacheProds
        this.$wait.end('product-creating')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('product-creating')
      })
    },
    getPiecesOfProcut() {
      console.log(this.$route.params)
      if(this.$route.params.id === undefined)
        return

      this.$wait.start('malzemeler-loading')
      axios.post('/api/stok/uretim-hesapla?sessionid=' + this.getSessionId + '&urunId=' + this.$route.params.id)
      .then(response => {
        let workingArr = []
        let cacheArr = response.data
        let lastSameIndex = -1;
        let lastMalzemeId = 0
        for(let l = 0; l < cacheArr.length; l++) {
          cacheArr[l].QUANTITIES = []
          for(let x = 0; x < this.calculatingProducts.length; x++) {
            cacheArr[l].QUANTITIES.push({'URUN_ID': this.calculatingProducts[x].URUN_ID, 'QTY': 0})
          }
        }

        for(let k = 0; k < cacheArr.length; k++) {
          let cObj = cacheArr[k];
          if(lastMalzemeId == cObj.MALZEME_ID) {
            let wObj = workingArr[lastSameIndex]
            for(let u = 0; u < wObj.QUANTITIES.length; u++) {
              if(cObj.URUN_ID == wObj.QUANTITIES[u].URUN_ID) {
                wObj.QUANTITIES[u].QTY = cObj.MALZEME_COUNT
                break
              }
            }
            workingArr[lastSameIndex] = wObj
          } else {

            let objToPush = cacheArr[k];
            for(let u = 0; u < objToPush.QUANTITIES.length; u++) {
              if(objToPush.URUN_ID == objToPush.QUANTITIES[u].URUN_ID) {
                objToPush.QUANTITIES[u].QTY = objToPush.MALZEME_COUNT
                break
              }
            }

            workingArr.push(objToPush)
            lastSameIndex = workingArr.length == 0 ? 0 : workingArr.length - 1
          }

          lastMalzemeId = cacheArr[k].MALZEME_ID
        }

        for(let j = 0; j < workingArr.length; j++) {
          workingArr[j].IS_ENOUGH = this.calcDifferenceMultiple(workingArr[j])
        }
        
        this.malzemeler = workingArr
        this.$wait.end('malzemeler-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('malzemeler-loading')
      })
    },
    calculate(e) {
      for(let i = 0; i < this.malzemeler.length; i++)
        this.malzemeler[i].IS_ENOUGH = this.calcDifferenceMultiple(this.malzemeler[i])
    },
    calcNeededTotal(malzemeId) {
      let malzeme = this.malzemeler.find(m => m.MALZEME_ID == malzemeId)
      if(malzeme == null) return 0

      let needed = 0
      for(let i = 0; i < malzeme.QUANTITIES.length; i++) {
        let usedCount = parseInt(malzeme.QUANTITIES[i].QTY)
        needed += usedCount * parseInt(this.calculatingProducts[i].QUANTITY)
      }

      return needed
    },
    calcDifference(malzemeId) {
      let malzeme = this.malzemeler.find(m => m.MALZEME_ID === malzemeId)
      if(malzeme == null) return 0

      let needed = parseInt(this.quantity) * parseInt(malzeme.MALZEME_COUNT)
      let having = parseInt(malzeme.MALZEME_LENOI) + parseInt(malzeme.MALZEME_FABRIKA)
      let difference = Math.abs(needed - having)
      let isEnough = having >= needed
      malzeme.IS_ENOUGH = isEnough
      return isEnough ? 0 : difference
    },
    calcDifferenceMultiple(malzeme) {
      let needed = 0
      for(let i = 0; i < malzeme.QUANTITIES.length; i++) {
        let usedCount = parseInt(malzeme.QUANTITIES[i].QTY)
        needed += usedCount * parseInt(this.calculatingProducts[i].QUANTITY)
      }

      let having = parseInt(malzeme.MALZEME_LENOI) + parseInt(malzeme.MALZEME_FABRIKA)
      let difference = Math.abs(needed - having)
      let isEnough = having >= needed
      malzeme.IS_ENOUGH = isEnough
      console.log(malzeme.MALZEME_NAME + ' needed: ' + needed + ' isEnough: ' + isEnough)
      return isEnough ? 0 : difference
    },
    askProduction() {
      if(this.calculatingProducts.filter(m => m.QUANTITY == 0).length > 0) {
        this.$toasted.error('Üretim adedi belirlemediğiniz ürünler var', this.toastOptions)
        return
      }

      //if(!(this.quantity && this.quantity > 0)) {
      //  this.$toasted.error('Üretim adedi belirlemediniz', this.toastOptions)
      //  return
      //}

      if(this.malzemeler.filter(m => m.IS_ENOUGH == 0).length > 0) {
        this.$toasted.error('Üretim için gerekli malzemelerde eksiklik var.', this.toastOptions)
        this.listingMode = 1
        return
      }

      $("#modalAskProduction").modal('show')
    },
    startProduction(type) {
      if(this.quantitiesByHand && type == 0) {
        //this.$router.push('/uretim/baslat/' + this.$route.params.id)
        $("#modalAskProduction").modal('hide')
        $("#modalQuantitiesByhand").modal('show')
        return
      }

      let json = {}
      json.SessionId = this.getSessionId
      json.Products = this.calculatingProducts
      json.ToFabric = []
      for(let i = 0; i < this.malzemeler.length; i++)
        json.ToFabric.push({'MALZEME_ID': this.malzemeler[i].MALZEME_ID, 'TO_FABRIC': this.malzemeler[i].TO_FABRIC})

      this.$wait.start('uretim-fabrika-stok')
      axios.post('/api/stok/uretim-baslat', json)
      .then(response => {
        this.$toasted.success('Üretim başlatıldı. Malzeme adetleri fabrika stokuna kaydırıldı.', this.toastOptions)
      })
      .catch(error => { 
        this.$toasted.error('Üretim başlatılamadı. Durum: ' + error.ErrorMessage, this.toastOptions)
        console.error(error)
      })
      this.$wait.end('uretim-fabrika-stok')   
    }
  },
  mounted() {
    this.getProduct()
    this.getPiecesOfProcut()
  }
}
</script>

<style scoped>

  th {
    font-weight: 500;
    color: inherit !important;
  }

  th label {
    font-weight: 400;
    padding-top: 2px;
  }

  .background-danger {
    background-color: rgba(220, 53, 69, 0.07);
    color: #FFF;
  }

  .background-success {
    background-color: rgba(40, 167, 69, 0.07);
    color: #FFF;
  }

  .font-semi-bold {
    font-weight: 500;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .75rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/UretimPage.vue